import {Button} from "antd";
import {FC, useState} from "react";
import {loginWithMicrosoft} from "../services/authService";
import {renderErrorMessage} from "./messages/errorMessage";

interface Props {
  onSuccess: (token: string) => void;
  disabled?: boolean;
}

const MicrosoftLoginButton: FC<Props> = ({ onSuccess, disabled }) => {
  const [loading, setLoading] = useState(false);
  const login = async () => {
    setLoading(true);
    try {
      const token = await loginWithMicrosoft();
      onSuccess(token);
    } catch (error) {
      renderErrorMessage(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button htmlType="button" block className="mt-1" disabled={disabled} loading={loading} onClick={login}>
      Log ind med Microsoft
    </Button>
  );
};

export default MicrosoftLoginButton;
